export default {
    setBookingForm (state, data) {
        state.bookingForm = data
    },
    setBooking (state, booking) {
        state.booking = booking
    },
    setBookingChangelog (state, booking) {
        state.bookingChangelog = booking
    },
    setIsReturnBooking (state, bool) {
        state.isReturnBooking = bool
    },
    setIncludeUnconfirmedBookings (state, bool) {
        state.includeUnconfirmedBookings = bool
    },
    setBookingTypesFilter (state, types) {
        state.bookingTypesFilter = types
    },
    setCustomerIdFilter (state, id) {
        state.customerIdFilter = id
    }
}
